export const updateFavicon = (file?: File, localUrl?: string | null) => {
  const link = document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "icon";
  link.id = "customIcon";
  if (file?.size) {
    const reader = new FileReader();
    reader.onloadend = () => {
      link.href = reader.result as string;
    };
    reader.readAsDataURL(file);
  } else {
    link.href = localUrl as string;
  }

  document.getElementsByTagName("head")[0].appendChild(link);
};
